import angularModule from 'Cohorts/angularModule/scripts/cohorts_module';

angularModule.factory('AdmissionRound', [
    '$injector',
    $injector => {
        const Iguana = $injector.get('Iguana');
        const SupportsRelativeDates = $injector.get('SupportsRelativeDates');

        return Iguana.subclass(function () {
            this.alias('AdmissionRound');
            this.embeddedIn('schedulableItem');
            this.include(SupportsRelativeDates);

            Object.defineProperty(this.prototype, 'applicationDeadline', {
                get() {
                    return this._getCachedRelativeDate('applicationDeadline', 'application_deadline_days_offset');
                },
            });

            Object.defineProperty(this.prototype, 'decisionDate', {
                get() {
                    return this._getCachedRelativeDate('decisionDate', 'decision_date_days_offset');
                },
                configurable: true,
            });

            Object.defineProperty(this.prototype, 'index', {
                get() {
                    return this.schedulableItem().admission_rounds.indexOf(this);
                },
            });

            Object.defineProperty(this.prototype, '_startDateForRelativeDates', {
                get() {
                    return this.schedulableItem().startDate;
                },
                configurable: true,
            });
        });
    },
]);
